export default {"src":"/minerva/_next/static/media/luxembourg-logo.dce9c82e.svg","height":423,"width":500,"blurWidth":0,"blurHeight":0};